<ui-fh-text [type]="'SMALL'" [text]="'generics.required_field_info' | translate"></ui-fh-text>
